import '../../Assets/Styles/quemsomos.css';

import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate} from 'react-router-dom';

import { Helmet } from 'react-helmet';

import { Carousel } from 'primereact/carousel';
import { Rating } from 'primereact/rating';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button'; 

import Grid from '@mui/material/Grid';

import jwtDecode from 'jwt-decode';

// Load Actions
import * as AppActions from '../../Store/Actions/App'

// Load Componentes
import HeaderView from '../../Components/Layout/Header';
import FaqView from '../../Components/Partner/Faq';
import AlertView from '../../Components/AlertModal';
import ReviewSwiper from '../../Components/ReviewSwiper';

// Set assets
import backgroundQuemSomosFullBlock2 from '../../Assets/Images/backgroundQuemSomosFullBlock2.png';

import backgroundQuemSomosFeatured from '../../Assets/Images/backgroundQuemSomosBlock1.png';
import backgroundQuemSomosFeaturedMobile from '../../Assets/Images/backgroundQuemSomosBlock1Mobile.png';
import backgroundQuemSomosFullBlock1 from '../../Assets/Images/backgroundQuemSomosFullBlock1.png';


import screeningImage from '../../Assets/Images/screeningImage.png';
import edoLogoOnly from '../../Assets/Images/edoLogoOnly.svg'; 
import iconDiversity from '../../Assets/Images/iconDiversity.svg';
import iconStar from '../../Assets/Images/iconStar.svg';
import iconSchool from '../../Assets/Images/iconSchool.svg';
import iconWork from '../../Assets/Images/iconWork.svg';
import iconLibrary from '../../Assets/Images/iconLibrary.svg';
import iconBusiness from '../../Assets/Images/iconBusiness.svg';
import iconPremium from '../../Assets/Images/iconPremium.svg';
import iconStar2 from '../../Assets/Images/iconStar2.svg';
import iconClosePanel from '../../Assets/Images/iconClosePanel.svg';
import iconOpenPanel from '../../Assets/Images/iconOpenPanel.svg';


import blogImage from '../../Assets/Images/blogImage.png';
import blogImage2 from '../../Assets/Images/blogImage2.png';
import blogImage3 from '../../Assets/Images/blogImage3.png';
import blogImage4 from '../../Assets/Images/blogImage4.png';

import photoGustavo from '../../Assets/Images/photoGustavo.png';
import photoBruno from '../../Assets/Images/photoBruno.png';

import imageFallback from '../../Assets/Images/imagePlaceholder.jpg'; 

import {
	getSlugWithId,
	handleClickScroll
} from '../../Components/Utils';


const foundersData = [
{
	"name": "Gustavo A. Novais",
	"photo": photoGustavo,
	"experiences": [
	{
		"icon": iconSchool,
		"activities": [
		"Médico pela UNI-RIO (CRM 52 77165-1)",
		"Doutor pela UNIFESP",
		"MBA executivo pela Fundação Dom Cabral"
		]
	},
	{
		"icon": iconWork,
		"activities": [
		"Residência em oftalmologia no Hospital municipal da Piedade-RJ",
		"Fellowship Córnea e doenças externas pela McGill University, Montreal/Canadá",
		"Fellowship Córnea e doenças externas pelo Hospital Oftalmológico de Sorocaba"
		]
	},
	{
		"icon": iconLibrary,
		"activities": [
		"Observership Harvard/Boston",
		"Observership Bascom Palmer Eye Institute/ Miami"
		]
	},
	{
		"icon": iconBusiness,
		"activities": [
		"Professor adjunto Universidade Federal Do Estado do RJ (UNI-RIO)",
		"Sócio Oftalmo Citta (agora parte do grupo Vision One)",
		"Co-fundador Rio Vision Hospital (inauguração 2024)"
		]
	},
	{
		"icon": iconPremium,
		"activities": [
		"Membro da comissão de ensino Sociedade Brasileira de Oftalmologia"
		]
	}
	]
},
{
	"name": "Bruno F. Fernandes",
	"photo": photoBruno,	
	"experiences": [
	{
		"icon": iconSchool,
		"activities": [
		"Médico pela UFRJ (CRM 52.72111-5)",
		"Doutor pela UNIFESP",
		"Pós-doutor pela McGill University",
		"Pós-doutor pela Toronto University",
		"Certificado em administração de empresas pela Concordia University, Montreal/Canadá"
		]
	},
	{
		"icon": iconWork,
		"activities": [
		"Residência em oftalmologia pelo Hospital Federal dos Servidores do Estado - RJ (RQE Nº: 50954)",
		"Fellowship patologia ocular pela McGill University, Montreal/Canadá"
		]
	},
	{
		"icon": iconBusiness,
		"activities": [
		"Fundador de diversas empresas no ramo de produtos e serviços",
		"Mentor de empreendedores jovens pelo programa Futurpreneur, no Canadá",
		"Consultor médico/científico de empresas da indústria farmacêutica"
		]
	},
	{
		"icon": iconStar2,
		"activities": [
		"Autor de 80+ publicações científicas"
		]
	}
	]
}
];
  

const QuemSomos = (props) => {
	
// Set var from props
const {
	setDialog,
	setLoginStatus,
	loginStatus,
	currentCompanyStatus,
	activationStatus,
	setActivationStatus,
	retrieveAppAddressGooglePlaces,
	retrieveAppAddressGoogleCoordinates
} = props;

const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

// set Use of history for PUSH 
var navigate = useNavigate();
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
	
const [indexAtivo, setIndexAtivo] = React.useState(0); // 0 - clinics -- 1 - optics
const [selectedService, setSelectedService] = React.useState(null); // 0 - clinics -- 1 - optics
const [address, setAddress] = React.useState(null);
const [addressObj, setAddressObj] = React.useState(null);
const [suggestions, setSuggestions] = React.useState(null);
const [loadingSuggestions, setLoadingSuggestions] = React.useState(false);

const [addressSelected, setAddressSelected] = React.useState(false);
const [coordinates, setCoordinates] = React.useState(null);

const [loading, setLoading] = React.useState(false);
const typingTimeoutRef = React.useRef(null);

// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 
const [alertAction, setAlertAction] = React.useState(null);

const DEBOUNCE_DELAY_MS = 1500; // Buffer de espera

// Blog news 
const [noticiasMidia, setNoticiasMidia] = React.useState([]);

const [openIndexes, setOpenIndexes] = React.useState({});

// Função para buscar posts
React.useEffect(() => {
	
	const buscarPostsMidia = async () => {
		try {
			let url = 'https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/posts?_embed&per_page=4&orderby=date&order=desc&categories=18';
			const res = await fetch(url);
			const data = await res.json();
			setNoticiasMidia(data);
		} catch (err) {
			console.error('Erro ao buscar posts:', err);
		}
	}
	buscarPostsMidia();
	window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);


// Função para lidar com o clique na postagem
const handleClick = (noticia) => {
	const url = getSlugWithId(noticia.title?.rendered, noticia.id);
	navigate(url);
};

const toggleOpen = (index) => {
  setOpenIndexes((prev) => ({
    ...prev,
    [index]: !prev[index],
  }));
};

// If not logged, show login screen
  return (
	<>
	<Helmet>
	  <title>Quem Somos</title>
	  <meta name="description" content="Conheça quem está por trás dessa iniciativa inovadora." />
	  <meta name="keywords" content="oftalmologia, clínica, saúde ocular, exames de vista" />
	</Helmet>	
	<div id="quemsomosMainSection" className="wrapper_quemsomos__content" style={{backgroundColor:'#FFFFFF'}}>

		<img src={isMobile ? backgroundQuemSomosFeaturedMobile : backgroundQuemSomosFeatured} className="wrapper_quemsomos__content_bgPhoto block1" />

		<HeaderView />

		<div className={isMobile ? "mobileWrapperBox wrapper_quemsomos__content_container" : "wrapper_quemsomos__content_container"}> 
		

			{/*<!-- Webdoor Slogan and descriptiob + CTA -->*/}
			<div className={isMobile ? "wrapper_quemsomos__content_container_block mobileWrapperBox" : "wrapper_quemsomos__content_container_block"} style={{height:isMobile ? "47rem" : "32rem"}}>  
				
				<div className="wrapper_quemsomos__content_container_webdoor" style={{alignItems:"flex-start",marginTop:"6.3rem"}}>

					<div className="w100 tAlignL"><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
					<div className="wrapper_quemsomos__content_container_webdoor_title w100">Sobre nós</div>	
					<div className="wrapper_quemsomos__content_container_webdoor_description">Fundada pelos visionários oftalmologistas Gustavo Novais e Bruno Fernandes, a Estação do Olho emerge como um farol de esperança e inovação, com a missão de democratizar o diagnóstico e tratamento de doenças oculares para todos os brasileiros.</div>
				</div>

			</div>	

		</div>			

		{/*<!-- Why EDO FULL Box -->*/}
		<div className="wrapper_quemsomos__content_full_container" style={{marginTop:"1rem",height:isMobile ? "104rem" : "94rem",overflow:"unset"}}>

			<img src={backgroundQuemSomosFullBlock1} className="wrapper_quemsomos__content_bgPhoto_full" />

			<div className="wrapper_quemsomos__content_container_highlight" style={{marginTop:"6rem",zIndex:"9"}}> 

				<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
				<div className="wrapper_quemsomos__content_container_highlight_title">A Estação do olho</div>
				<div className="wrapper_quemsomos__content_container_highlight_description" style={{width:"100%",maxWidth:"50rem",marginLeft:"auto",marginRight:"auto"}}>A origem da Estação do Olho reside no espírito empático e inovador de seus fundadores, que identificaram uma disparidade alarmante no conhecimento sobre os sintomas das doenças oculares mais comuns e no acesso à saúde ocular no país. Diante de uma realidade onde uma grande parcela da população estava desprovida de cuidados oftalmológicos básicos, Gustavo e Bruno foram movidos pela convicção de que a saúde ocular é um direito de todos, e não um privilégio de poucos.</div>

			</div>			

			{/*<!-- 2 cards -->*/}
			<div className="wrapper_quemsomos__content_container_block block2" style={{marginTop:isMobile ? "32rem" : "29rem"}}>  

				<div className="wrapper_quemsomos__content_container_cards" style={{marginTop:"1rem"}}>

					<div className="card cardScreening" style={{maxWidth:"34rem",width:"50%"}}>
						<div className="cardScreening__icon"><img src={iconDiversity} style={{width:"1.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">O que nos motiva</div>
						<div className="cardScreening__description">Nosso propósito é levar qualidade de vida e bem estar à população brasileira através da conscientização sobre os sintomas das doenças oculares, promoção da saúde ocular, e facilitação do acesso ao diagnóstico e tratamento de qualidade.</div>
						
					</div>

					<div className="card cardScreening" style={{maxWidth:"34rem",width:"50%"}}>
						<div className="cardScreening__icon"><img src={iconStar} style={{width:"1.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Nossa proposta de valor</div>
						<div className="cardScreening__description">Impactar a saúde ocular brasileira oferecendo aos nossos clientes uma solução inteligente, simples e acessível focada na prevenção da cegueira. Queremos ser o elo que conecta os pacientes e profissionais capacitados de maneira precoce oferecendo acesso de qualidade e mais igualitário à saúde ocular.</div>						
					</div>

				</div>				

			</div>					
			        
			{/*<!-- Bottom text -->*/}
			<div className="wrapper_quemsomos__content_container_block" style={{marginTop:isMobile ? "0rem" : "2rem",backgroundColor: "#4d4792",padding: "1rem"}}>  

				<div className="wrapper_quemsomos__content_container_highlight bottom" style={{marginTop:"0.75rem",padding:"1.5rem"}}>

					<div className="wrapper_quemsomos__content_container_highlight_description fWhite" style={{fontSize:"1.25rem",textAlign:"justify",width:"100%",maxWidth:"50rem",marginLeft:"auto",marginRight:"auto"}}>Estamos no negócio de promover o acesso inclusivo à saúde ocular de qualidade, utilizando tecnologia inovadora para <strong>prevenir a cegueira e melhorar a qualidade</strong> de vida de pessoas que tradicionalmente têm menos acesso a cuidados médicos. 
					<br /><br />
					Nosso objetivo é <strong>empoderar nossos clientes com informações e soluções acessíveis</strong> para proteger e melhorar sua visão, ao mesmo tempo em que conectamos profissionais de saúde e óticas a uma plataforma que amplifica o impacto social e comercial de seus serviços.
					</div>

				</div>					

			</div>					


		</div>


		{/*<!-- Founders Block -->*/}
		<div className="wrapper_quemsomos__content_container" style={{marginTop:isMobile ? "27rem" : "1.5rem"}}>

			{/*<!-- CTA BOX  -->*/}
			<div className="wrapper_quemsomos__content_container_block flex-row justify-center align-items-end" style={{flex:1}}>  
				
				<div className="wrapper_quemsomos__content_container_foundationsbox">
				
					<div className="wrapper_quemsomos__content_container_highlight" style={{marginTop:isMobile ? "12.5rem !important" : "2.5rem"}}>
						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
						<div className="wrapper_quemsomos__content_container_highlight_title">Fundadores</div>
					</div>	

					<div className="wrapper_quemsomos__content_container_foundationsbox_cards" style={{marginTop:"3.5rem"}}>

						{foundersData.map((founder, index) => {

							const isOpen = openIndexes[index];
												
						return (
							<div key={index} className="card cardFounders">
							<div className="photo">
								<img src={founder.photo} className="noSelect" alt={founder.name} />
							</div>
							<div className="content">
								<div className="name w100" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<span>{founder.name}</span>
									{isMobile && (
										<button
										className="panelButton"
										onClick={() => toggleOpen(index)}
										style={{
											fontSize: '1.5rem',
											cursor: 'pointer'
										}}
										aria-label="Abrir ou fechar experiência"
										>
										 <img src={!isOpen ? iconOpenPanel : iconClosePanel} className="noSelect" />
										</button>
									)}
								</div>
								<div
								className="experience"
								style={{
									maxHeight: isMobile ? (isOpen ? '1000px' : '0') : 'none',
									overflow: !isOpen ? 'hidden' : 'unset',
									transition: 'height,max-height 1s ease'
								}}
								>
								{founder.experiences.map((exp, expIndex) => (
									<div key={expIndex} className="experience_block">
									<div className="experience_icon">
										<img src={exp.icon} className="noSelect" alt="icon" />
									</div>
									<div className="experienceActivity_block">
										{exp.activities.map((activity, actIndex) => (
										<div key={actIndex} className="experienceActivity">
											{activity}
										</div>
										))}
									</div>
									</div>
								))}
								</div>
							</div>
							</div>
						)}
						)}						
						
						{/*
						<div className="card cardFounders">
							<div className="photo"><img src={photoGustavo} className="noSelect" /></div>
							<div className="content"> 

								<div className="name">Gustavo A. Novais</div>

								<div className="experience">

									<div className="experience_block">
										<div className="experience_icon"><img src={iconDiversity} className="noSelect" /></div>
										<div className="experienceActivity_block">						
											<div className="experienceActivity">ACTIVITY</div>
											<div className="experienceActivity">ACTIVITY</div>
											<div className="experienceActivity">ACTIVITY</div>
										</div>
									</div>

									<div className="experience_block">
										<div className="experience_icon"><img src={iconDiversity} className="noSelect" /></div>
										<div className="experienceActivity_block">						
											<div className="experienceActivity">ACTIVITY</div>
											<div className="experienceActivity">ACTIVITY</div>
											<div className="experienceActivity">ACTIVITY</div>
										</div>
									</div>	

								</div>							

							</div>
						</div>		

						<div className="card cardFounders">
							<div className="photo"><img src={photoBruno} className="noSelect" /></div>
							<div className="content">

								<div className="name">Bruno F. Fernandes</div>

								<div className="experience">

									<div className="experience_block">
										<div className="experience_icon"><img src={iconDiversity} className="noSelect" /></div>
										<div className="experienceActivity_block">						
											<div className="experienceActivity">ACTIVITY <span>LIGHT</span></div>
											<div className="experienceActivity">ACTIVITY</div>
											<div className="experienceActivity">ACTIVITY</div>
										</div>
									</div>

									<div className="experience_block">
										<div className="experience_icon"><img src={iconDiversity} className="noSelect" /></div>
										<div className="experienceActivity_block">						
											<div className="experienceActivity">ACTIVITY</div>
											<div className="experienceActivity">ACTIVITY</div>
											<div className="experienceActivity">ACTIVITY</div>
										</div>
									</div>	

								</div>							

							</div>
						</div>								
						*/}
	
					</div>

				</div>			

			</div>

		</div>

		{/*<!-- Diferencial FULL Box -->*/}
		<div className="wrapper_quemsomos__content_full_container" style={{marginTop:"6.24rem",mingHeight:"45rem",overflow:"hidden"}}> 
			<img src={backgroundQuemSomosFullBlock2} className="wrapper_quemsomos__content_bgPhoto" style={{minHeight:"608px"}} />

			{/*<!-- CTA BOX  -->*/}
			<div className="wrapper_quemsomos__content_container_block flex-row justify-center align-items-end" style={{flex:1}}>  
				
				<div className="wrapper_quemsomos__content_container_diferencialbox" style={{    width:isMobile ? "100%" : "82rem",padding:isMobile ? "unset" : ""}}>

					<div className="wrapper_quemsomos__content_container_diferencialbox_left">
						<ReviewSwiper />
					</div>								
	
				</div>
			</div>

		</div>


		{/*<!-- Blog Highlights BOX -->*/}
		<div className="wrapper_quemsomos__content_container"> 
		
			{/*<!-- Blog Highlight with 4 cards -->*/}
			<div className="wrapper_quemsomos__content_container_block">  

				<div className="wrapper_quemsomos__content_container_highlight" style={{marginTop:"6.5rem"}}>

						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
						<div className="wrapper_quemsomos__content_container_highlight_title">Estação do Olho na Mídia</div>
						<div className="wrapper_quemsomos__content_container_highlight_description">Nosso impacto na saúde ocular já foi destaque em diversas publicações. Confira!</div>

				</div>

				<div className="wrapper_quemsomos__content_container_cards wrapper_home__content_container_cardsBlog" style={{flexWrap:"nowrap",marginTop:"3.5rem"}}>

					{noticiasMidia.map(post => {
						
						const midia = post._embedded?.['wp:featuredmedia']?.[0];
						const image = midia?.media_details?.sizes?.medium?.source_url
						|| midia?.media_details?.sizes?.thumbnail?.source_url
						|| midia?.source_url;	

						//const category = post._embedded?.['wp:term']?.[0]?.[0]?.name || 'Sem categoria';

						const categories = post._embedded?.['wp:term']?.[0] || [];

						// Função para remover acentos
						const sanitize = (str) => {
						  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '');
						};						

						return (
							<div key={post.id} className="card cardBlog applyPointer" onClick={() => handleClick(post)}>
							<div className="cardBlog__image">
								<img src={image || imageFallback} className="noSelect" alt={post.title.rendered}   onError={(e) => { 
									e.target.onerror = null; // evita loop infinito
									e.target.src = imageFallback;
								}} />
							</div>
							<div className="cardBlog__category media">

								{categories.map((cat, idx) => (
									<span key={idx} className={sanitize(cat.name)}>{cat.name}</span>
								))}	

								{categories.length == 0 && (
									<span className="semCategoria">Sem categoria</span>
								)}

							</div>
							<div className="cardBlog__title" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
							<div className="cardBlog__description" dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
							</div>
						);
					})}	

				</div>		

				<div className="wrapper_quemsomos__content_container_cta" style={{marginTop:"2.5rem",marginBottom:"7.31rem"}}><Button label="Encontre um especialista" rounded className="pT10 headerButtonRight filled" style={{marginTop:"0.5rem",marginBottom:"3rem"}} onClick={()=>navigate("/")}   /></div>

			</div>	
		
		</div>


	</div>

	  <AlertView
		alert={alert}
		setAlert={setAlert}
		alertTitle={alertTitle}
		alertBody={alertBody}	
		setAlertAction={setAlertAction}
		scrollBlock={false}			
	  />

	</>
  );
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  loginStatus:store.appReducer.loginStatus,
  currentCompanyStatus:store.appReducer.currentCompanyStatus,
  activationStatus:store.appReducer.activationStatus
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(QuemSomos);	


